import { Controller, type Control } from "react-hook-form";

import { TraderDetailsProfileField } from "../TraderDetailsProfileField";
import { TraderDetailsProfileSelect } from "../TraderDetailsProfileSelect";
import type { SelectOption, TraderDetailsStepOneFormValues } from "../TraderDetailsStepOne/types";

interface TraderDetailsTraderTypeFieldProps {
  control: Control<TraderDetailsStepOneFormValues>;
  errorMessage: string;
  isDisabled?: boolean;
  label: string;
  options: SelectOption[];
  placeholder: string;
}

export const TraderDetailsTraderTypeField = ({
  control,
  errorMessage,
  isDisabled = false,
  label,
  options,
  placeholder,
}: TraderDetailsTraderTypeFieldProps) => (
  <Controller
    control={control}
    name="trader_type"
    render={({ field }) => (
      <TraderDetailsProfileField
        id="trader-type-select"
        label={label}
        errorMessage={errorMessage}
        required
      >
        <TraderDetailsProfileSelect
          id="trader-type-select"
          value={field.value}
          options={options}
          placeholder={placeholder}
          errorMessage={errorMessage}
          isDisabled={isDisabled}
          onBlur={field.onBlur}
          onChange={field.onChange}
        />
      </TraderDetailsProfileField>
    )}
  />
);
